<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 600px; max-width: 90vw;">
      <q-card-section>
        <div class="text-h6">Edit Space</div>
      </q-card-section>

      <q-card-section>
        <q-form @submit.prevent="handleSubmit">
          <q-select
            :model-value="formData.brick_class"
            :options="spaceBrickClasses"
            label="BRICK Class"
            filled
            required
            emit-value
            map-options
            class="q-mb-md"
            @update:model-value="$emit('update:brick-class', $event)"
          />
          <q-input
            :model-value="formData.name"
            label="Space Name"
            filled
            required
            class="q-mb-md"
            @update:model-value="$emit('update:name', $event)"
          />
          <q-input
            :model-value="formData.description"
            label="Description"
            filled
            type="textarea"
            rows="3"
            class="q-mb-md"
            @update:model-value="$emit('update:description', $event)"
          />

          <!-- Space Metadata Section -->
          <q-separator class="q-my-md" />
          <div class="text-subtitle2 q-mb-md">Space Metadata (Optional)</div>

          <div class="row q-col-gutter-md q-mb-md">
            <div class="col-8">
              <q-input
                :model-value="formData.area"
                label="Area"
                filled
                type="number"
                step="0.01"
                min="0"
                hint="Space area"
                @update:model-value="$emit('update:area', $event)"
              />
            </div>
            <div class="col-4">
              <q-btn-toggle
                :model-value="formData.metadata.area_unit_id"
                :options="[
                  { label: 'm²', value: 41 },
                  { label: 'ft²', value: 42 }
                ]"
                toggle-color="primary"
                color="grey-3"
                text-color="grey-8"
                spread
                unelevated
                @update:model-value="$emit('update:area-unit-id', $event)"
              />
            </div>
          </div>
        </q-form>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('update:modelValue', false)" />
        <q-btn color="primary" label="Update Space" :loading="saving" @click="handleSubmit" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    spaceBrickClasses: {
      type: Array,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:brick-class',
    'update:description',
    'update:area',
    'update:area-unit-id',
    'submit',
  ]);

  const handleSubmit = () => {
    emit('submit');
  };
</script>
